export default __webpack_public_path__ + "static/media/MultipleExcelSheets.4b74f381.png";